import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconClipboardAt32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconClipboardAt32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M13 5h6v2h-6zm-2 0a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2h2a4 4 0 0 1 4 4v2.101a7 7 0 0 0-2-1.427V9a2 2 0 0 0-2-2h-2a2 2 0 0 1-2 2h-6a2 2 0 0 1-2-2H9a2 2 0 0 0-2 2v15a2 2 0 0 0 1.66 1.971A7 7 0 0 0 10.101 28H9a4 4 0 0 1-4-4V9a4 4 0 0 1 4-4zm7.5 17c.89 0 2-.891 2-2.5s-1.11-2.5-2-2.5-2 .891-2 2.5 1.11 2.5 2 2.5m2.282-6.196A3.7 3.7 0 0 0 18.5 15c-2.21 0-4 2.015-4 4.5s1.79 4.5 4 4.5c.88 0 1.694-.32 2.355-.862A2 2 0 0 0 22.5 24H24a3 3 0 0 0 3-3v-3a7 7 0 0 0-7-7h-3a7 7 0 0 0-7 7v3a7 7 0 0 0 7 7h8.88a1 1 0 1 0 0-2H17a5 5 0 0 1-5-5v-3a5 5 0 0 1 5-5h3a5 5 0 0 1 5 5v3a1 1 0 0 1-1 1h-1.5v-5.5a1 1 0 0 0-1.718-.696"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconClipboardAt32);
